import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

function warnIfClash(ours, theirs) {
  var ourKeys = Object.keys(ours);
  var theirKeys = Object.keys(theirs);
  ourKeys.forEach(function (key) {
    if (theirKeys.includes(key)) {
      // eslint-disable-next-line no-console
      console.warn("\n          FieldText:\n          You are attempting to add prop \"".concat(key, "\" to the input field.\n          It is clashing with one of our supplied props.\n          Please try to control this prop through our public API\n        "));
    }
  });
}

export default function Input(_ref) {
  var elemAfterInput = _ref.elemAfterInput,
      elemBeforeInput = _ref.elemBeforeInput,
      isDisabled = _ref.isDisabled,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      onMouseDown = _ref.onMouseDown,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      theme = _ref.theme,
      innerRef = _ref.innerRef,
      testId = _ref.testId,
      theirInputProps = _objectWithoutProperties(_ref, ["elemAfterInput", "elemBeforeInput", "isDisabled", "isReadOnly", "isRequired", "onMouseDown", "onMouseEnter", "onMouseLeave", "onBlur", "onFocus", "theme", "innerRef", "testId"]);

  var ourInputProps = {
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired
  }; // Check for any clashes when in development

  if (process.env.NODE_ENV !== 'production') {
    warnIfClash(ourInputProps, theirInputProps);
  }

  var inputProps = _objectSpread(_objectSpread({}, theirInputProps), ourInputProps);

  var containerProps = {
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
  return jsx("div", _extends({}, containerProps, {
    css: theme.container
  }), elemBeforeInput, jsx("input", _extends({}, inputProps, {
    css: theme.input,
    ref: innerRef,
    "data-testid": testId
  })), elemAfterInput);
}